export default function kebabCase(value) {
  return value
    .toLowerCase()
    .replaceAll(' & ', ' and ')
    .replaceAll(' ', '-')
    .replaceAll('.', '')
    .replaceAll(',', '')
    .replaceAll("'", '');
}
